import {
  HeroData,
  HowItWorksData,
  MealPlansData,
  HighlightedFeaturesData,
  ScienceSectionData,
  ReviewsBlockData,
  FeatureBlockData,
  InfoSectionData,
  FaqData,
  TestimonialsData,
} from 'js/pages/LandingPages/components/types'
import { lpImages } from 'js/pages/LandingPages/imageSources'

export const APP_STORE_LINK =
  'https://app.adjust.com/16y3wy6h_16d788jv?engagement_type=fallback_click'

export const heroData: HeroData = {
  label: 'Features',
  title: 'Take the guesswork out of healthy eating',
  subtitle: 'Find out how Lifesum can help you eat and feel well, every day.',
  items: [
    {
      name: 'Verified nutritional information',
      image: lpImages.pearIcon,
    },
    {
      name: 'Sync with Fitbit, Apple watch, Google watch & more',
      image: lpImages.pearIcon,
    },
    {
      name: 'Cancel anytime',
      image: lpImages.pearIcon,
    },
  ],
  btn1Name: 'Sign up now',
  btn2Name: 'Download the app',
  image: lpImages.heroImage,
}

export const howItWorksData: HowItWorksData = {
  image: lpImages.howItWorksImage,
  title: 'How it works',
  items: [
    {
      counter: 1,
      image: lpImages.howItWorksImage1,
      desc: 'Specify if you want to lose weight, keep your current weigh or gain weight & set a goal.',
    },
    {
      counter: 2,
      image: lpImages.howItWorksImage1,
      desc: ' Get a personalized recommended daily calorie intake, plan your own meals or get a meal plan.',
    },
    {
      counter: 3,
      image: lpImages.howItWorksImage1,
      desc: 'Keep to the calorie intake plan and see results.',
    },
  ],
}

export const testimonialsData: TestimonialsData = {
  title: 'What users say about Lifesum',
  testimonials: [
    {
      image: lpImages.testimonial1,
      testimonial:
        '“The best thing about Lifesum is the full overview you get on your nutrition. I’ve learned how to prioritize nutritious food which makes me even more motivated to continue my journey. I’ve tried other similar apps before, but Lifesum is really easy to use and stick to.”',
      author: ' Marianne',
    },
    {
      image: lpImages.testimonial2,
      testimonial:
        '“Without Lifesum, my life would have become a roller coaster. It had taken significantly more time to find the optimal diet for me. And if I found it, it would have been more difficult to get it implemented without Lifesum”',
      author: ' Bjarne Simonsen',
    },
  ],
}

export const mealPlansData: MealPlansData = {
  label: 'Meal plans & recipes',
  title: 'Meal plans helps you simplify healthy eating',
  desc: 'Discover a path to wellness with our nourishing meal plan. Delight in the goodness of natural, healthy ingredients designed to enhance your overall wellbeing.',
  subTitle: 'Some of the meal plans to choose from',
  items: [
    {
      name: '16:8 Morning fast',
      image: lpImages.mealPlanImage1,
    },
    {
      name: 'Clean eating',
      image: lpImages.mealPlanImage2,
    },
    {
      name: 'Keto Burn',
      image: lpImages.mealPlanImage3,
    },
    {
      name: 'Lifesum standard',
      image: lpImages.mealPlanImage4,
    },
  ],
}

export const highlightedFeaturesData: HighlightedFeaturesData = {
  title: 'Highlighted features',
  items: [
    {
      image: lpImages.cardImage1,
      title: 'Barcode scanner',
      desc: "You don't have to add food items manually, but can identify them with the super simple barcode scanner.",
    },
    {
      image: lpImages.cardImage2,
      title: 'Habits tracker',
      desc: 'Set up water, fruit and vegetable registration with one click to create long-term healthy habits. Repetition is key!',
    },
    {
      image: lpImages.cardImage3,
      title: 'Detailed nutritional information',
      desc: 'Millions of food items (including from the National Food Agency) and detailed nutritional information such as calories, fat, carbohydrates and protein content mean we can calculate everything for you.',
    },
  ],
  btnName: 'Download the app',
}

export const scienceSectionData: ScienceSectionData = {
  title: 'Manage your health with an app backed by science',
  items: [
    {
      image: lpImages.cardImage4,
      title: 'Nutrition knowledge',
      desc: 'Providing a person with nutritional information, preferably combined with coaching and recommendations leads to healthier dietary choices, as well as impacts clinical outcomes such as obesity t',
    },
    {
      image: lpImages.cardImage5,
      title: 'Mindfulness about eating',
      desc: 'Supporting people to attain a more mindful disposition regarding foods is a potent means of achieving successful weight management. It does, however, require support in terms of tracking calories continuously, as well as recommending meals or recipes',
    },
    {
      image: lpImages.cardImage3,
      title: 'Macronutrient balance',
      desc: 'To achieve goals relating to weight loss, muscle growth, weight management, freedom from cardiovascular disease or cancers, as well as promoting longevity, an active balancing of macronutrients is required.',
    },
  ],
  linkName: 'See our list of references',
}

export const reviewsBlockData: ReviewsBlockData = {
  title: 'Join +60 million users in eating healthier today',
  items: [
    '"Jag älskar denna app! Den har så många funktioner och goda råd. Med olika kostscheman och den exakta kaloriräkningen är denna app perfekt för mig."',

    '"Jag älskar denna app! Den har så många funktioner och goda råd. Med olika kostscheman och den exakta kaloriräkningen är denna app perfekt för mig an och den exakta kaloriräkningen är denna app perfekt för mig."',

    '"Jag älskar denna app! Den har så många funktioner och goda råd. Med olika kostscheman och den exakta kaloriräkningen är denna app perfekt för mig."',
  ],
  img1: lpImages.iphoneIcon,
  rating1: '4.6',
  img2: lpImages.androidIcon,
  rating2: '4.4',
  text: 'Based on 920, 957 reviews',
}

export const featureBlockData: FeatureBlockData = {
  title: 'Other useful features',
  featureItems: [
    `<strong class="font-demibold">Track </strong> and <strong class="font-demibold"> set</strong> macronutrient goals`,
    `<strong class="font-demibold"> Save your favorite meals and recipes </strong> for easy tracking`,
    `Life score helps you <strong class="font-demibold"> keep track of your food intake and activity </strong>`,
    `<strong class="font-demibold">Get ratings for food </strong> to easily see what will make you feel good`,
    `See <strong class="font-demibold"> detailed nutritional information </strong> for each meal`,
    `<strong class="font-demibold">Sync with your wearables </strong> and health apps (Apple Health, Google Fit, Samsung Health, Fitbit and Whitings)`,
    `Get <strong class="font-demibold"> detailed statistics </strong> so you can be fully in charge of your progress`,
    `Simplify eating with <strong class="font-demibold"> personalized meal plans </strong> that includes <strong class="font-demibold">weekly shopping lists</strong>`,
    `Set your own <strong class="font-demibold">daily calorie goal</strong> if you want to speed things up or take it more slowly`,
    `Never get bored with thousands of <strong class="font-demibold"> easy-to-cook recipes</strong>`,
  ],
}

export const faqData: FaqData = {
  title: 'Frequently asked questions',
  text: 'Is your question not answered here?',
  linkName: 'Go to the Lifesum support pages',
}

export const faqItemData = [
  {
    question: 'Can I sync workouts with Lifesum?',
    answer:
      '<strong>Yes!</strong> Lifesum can be connected to most popular health apps and wearables like Apple Health, Google Fit, Samsung Health, Fitbit and Whitings.',
  },
  {
    question: 'Can I sync workouts with Lifesum1?',
    answer:
      'Yes! Lifesum can be connected to most popular health apps and wearables like Apple Health, Google Fit, Samsung Health, Fitbit and Whitings.',
  },
  {
    question: 'Can I sync workouts with Lifesum2?',
    answer:
      'Yes! Lifesum can be connected to most popular health apps and wearables like Apple Health, Google Fit, Samsung Health, Fitbit and Whitings.',
  },
  {
    question: 'Can I sync workouts with Lifesum3?',
    answer:
      'Yes! Lifesum can be connected to most popular health apps and wearables like Apple Health, Google Fit, Samsung Health, Fitbit and Whitings.',
  },
  {
    question: 'Can I sync workouts with Lifesum4?',
    answer:
      'Yes! Lifesum can be connected to most popular health apps and wearables like Apple Health, Google Fit, Samsung Health, Fitbit and Whitings.',
  },
  {
    question: 'Can I sync workouts with Lifesum5?',
    answer:
      'Yes! Lifesum can be connected to most popular health apps and wearables like Apple Health, Google Fit, Samsung Health, Fitbit and Whitings.',
  },
]

export const infoSection1: InfoSectionData = {
  title: 'Get the app and start eating healthily today',
  description:
    'You can download the app and get started for free, sign up later if you like it.',
  listDescription:
    'With the free version you will get access to these fantastic benefits:',
  items: ['Free benefit 1', 'Free benefit 2', 'Free benefit 3'],
  image: lpImages.infoSectionImage,
  btnName: 'Download the app',
}

export const infoSection2: InfoSectionData = {
  title: 'Still wondering if Lifesum is for you?',
  description:
    'Get started for free by downloading the app and sign up later if you like it.',
  items: ['Free benefit 1', 'Free benefit 2', 'Free benefit 3'],
  image: lpImages.infoSectionImage2,
  btnName: 'Download the app',
}
